var React = require('react');

function IconSmartphoneInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Smartphone"),React.createElement("g",{"id":"Page-1","key":1},React.createElement("g",{"id":"v02"},React.createElement("g",{"id":"noun_iPhone_1740393-Copy-18","data-name":"noun iPhone 1740393-Copy-18"},React.createElement("g",{"id":"Group"},React.createElement("path",{"id":"Shape","d":"M3.78.23A3.78,3.78,0,0,0,0,4V50.8a3.78,3.78,0,0,0,3.78,3.8H25.22A3.78,3.78,0,0,0,29,50.8V4A3.78,3.78,0,0,0,25.22.23ZM2.52,5.29h24V44.48h-24Zm12,41.09a3.16,3.16,0,1,1-3.15,3.16A3.15,3.15,0,0,1,14.5,46.38Z","transform":"translate(0 -0.23)"})))))]);
}

IconSmartphoneInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 29 54.37"};

module.exports = IconSmartphoneInline;

IconSmartphoneInline.default = IconSmartphoneInline;
